import { useRouter } from 'next/router';
import React, {
  ElementRef,
  KeyboardEvent,
  ReactElement,
  ReactNode,
  useEffect,
  useState,
} from 'react';
import { useRef } from 'react';
import AnimateHeight, { Height } from 'react-animate-height';

type GlobalNavigationDropdownProps = {
  top?: number;
  children?: ReactNode;
  componentToPassDown?: ReactElement;
  className?: string;
};

const GlobalNavigationDropdown: React.FC<GlobalNavigationDropdownProps> = ({
  componentToPassDown,
  children,
  className,
}) => {
  const dropdown = useRef<ElementRef<'button'>>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  let overlay = false;
  const [height, setHeight] = useState<Height>(0);
  const router = useRouter();

  const handleKeyUp = (event: KeyboardEvent<HTMLButtonElement>): void => {
    if (event.key === 'Enter') {
      dropdown.current?.click();
      // $emit('enter');
    } else if (event.key === 'Esc') {
      dropdown.current?.click();
      overlay = false;
    }
  };

  const handleClickOutside = (event: MouseEvent): void => {
    if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
      setHeight(0);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    router.events.on('routeChangeStart', () => setHeight(0));
    return () => {
      router.events.off('routeChangeStart', () => setHeight(0));
    };
  }, [router]);

  return (
    <div className={`relative ${className}`} ref={containerRef}>
      {overlay && <div className="overlay" />}
      <button
        ref={dropdown}
        className="btn btn-naked d-flex collapsed dropdown-trigger"
        aria-expanded={height === 0 ? 'false' : 'true'}
        aria-controls="copyright-content"
        data-toggle="collapse"
        onKeyUp={handleKeyUp}
        onClick={() => setHeight(height === 0 ? 'auto' : 0)}
      >
        {children}
      </button>
      <AnimateHeight
        id="copyright-content"
        className={height === 0 ? 'd-none' : ''}
        height={height}
        duration={500}
      >
        <div
          className={`collapse dropdown-content pt-2 ${height !== 0 && 'show'}`}
          style={{ top: '0px' }}
        >
          {componentToPassDown}
        </div>
      </AnimateHeight>
    </div>
  );
};
export default GlobalNavigationDropdown;
